"use client";
import { jsxs as r, jsx as l } from "react/jsx-runtime";
const a = ({
  title: e,
  titleId: i,
  desc: n,
  descId: d,
  ...h
}) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": d,
    ...h,
    children: [
      n ? /* @__PURE__ */ l("desc", { id: d, children: n }) : null,
      e ? /* @__PURE__ */ l("title", { id: i, children: e }) : null,
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M22.5 21.75h-4.6415v-6.5916c0-1.725-.7254-2.9029-2.3224-2.9029-1.2208 0-1.9.795-2.216 1.5609-.1188.2747-.1002.6577-.1002 1.0406v6.893h-4.598s.0592-11.6761 0-12.7373h4.598v1.9992c.2721-.8742 1.7411-2.1216 4.0855-2.1216 2.9089 0 5.1946 1.8319 5.1946 5.7774zM3.9723 7.4194h-.0301C2.4607 7.4194 1.5 6.4458 1.5 5.2116 1.5 3.9534 2.489 3 4.0004 3c1.5101 0 2.4389.951 2.468 2.2078 0 1.2342-.9579 2.2116-2.4961 2.2116M2.0298 9.0127h4.093V21.75h-4.093z",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
export {
  a as default
};
